export const editorConfiguration = {
  toolbar: {
    viewportTopOffset: 50,
  }
}